import type { HelpFile } from '../../types/help'
import { RestrictionRuleDetectionsTestIds } from '../../../testids/RestrictionRuleDetectionsTestIds'

export const restrictionRuleDetectionsHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [RestrictionRuleDetectionsTestIds.restrictionRuleDetections]:
      'Erkennungsläufe über alle Restriktionsregeln — Regelfilter einsetzen, um auf eine bestimmte Regel einzugrenzen.',
    [RestrictionRuleDetectionsTestIds.btnClearRuleFilter]:
      'Erkennungen aller Restriktionsregeln anzeigen.',
    [RestrictionRuleDetectionsTestIds.colRule]:
      'Restriktionsregel, die diesen Erkennungslauf ausgelöst hat.',
    [RestrictionRuleDetectionsTestIds.colDetectionStartedAt]:
      'Beginn des Erkennungslaufs.',
    [RestrictionRuleDetectionsTestIds.colStatus]:
      'Ergebnis des Erkennungslaufs — läuft, abgeschlossen oder fehlgeschlagen.',
    [RestrictionRuleDetectionsTestIds.colIdentitiesEvaluated]:
      'Vom Erkennungslauf geprüfte Identitäten.',
    [RestrictionRuleDetectionsTestIds.colViolationsFound]:
      'In diesem Lauf neu erkannte Verstöße.',
    [RestrictionRuleDetectionsTestIds.colViolationsResolved]:
      'Zuvor offene Verstöße, die dieser Lauf bereinigt hat.',
  },
}
